export const logo = "/logo_light.svg"
export const whiteLogo = "/logo_white.svg"